import request from '@/utils/request'
import global from '@/Global'

export function dologin (data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

export function login (params) {
  return request({
    url: global.api + '/user/login',
    method: 'get',
    params: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getInfo (token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout () {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

export function getUserList (params) {
  return request({
    url: global.api + '/user/list',
    method: 'get',
    params: params // get 时使用params
  })
}

export function createUser (params) {
  return request({
    url: global.api + '/user/insert',
    method: 'post',
    data: JSON.stringify(params), // post时使用data
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function updateUser (params) {
  return request({
    url: global.api + '/user/update',
    method: 'put',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function deleteUser (params) {
  return request({
    url: global.api + '/user/delete',
    method: 'delete',
    params: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function openUser (params) {
  return request({
    url: global.api + '/user/openUser',
    method: 'post',
    data: JSON.stringify(params), // post时使用data
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function chgpwd (params) {
  return request({
    url: global.api + '/user/changPassword',
    method: 'put',
    params: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}


// 获取当前用户的菜单与角色ser/getMenu
export function getMenu (params) {
  return request({
    method:'get',
    url: global.api + '/user/getMenu',
    params: params,
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js